const options = [
  { value: 'score.irc', label: 'query.logs.score.irc' },
  { value: 'score.punctual', label: 'query.logs.punctual.adjust' },
  { value: 'score.stock.request', label: 'query.logs.score.stock.request' },
  { value: 'score.stock.response', label: 'query.logs.score.stock.response' },
  {
    value: 'pricebanner.preview.request',
    label: 'query.logs.pricebanner.preview.request',
  },
  { value: 'pricebanner.request', label: 'query.logs.pricebanner.request' },
  { value: 'datasheet.preview.request', label: 'issuance.datasheet' },
  { value: 'datasheet.request', label: 'preview.ficha.tecnical' },
  { value: 'request.external', label: 'query.logs.request.external' },
  {value: "use.consume", label: "Uso e consumo - Retorno do faturamento"}
]

export { options }
